import { ContentComponent, ModuleRepeaterComponent } from "@/types/modules";
import Content from "../Content";
import Gallery from "../Gallery";

interface ModuleRepeaterItemProps {
  module: ModuleRepeaterComponent;
}

export default function ModuleRepeaterItem({
  module,
}: ModuleRepeaterItemProps) {
  const content: ContentComponent = {
    imageAlign: module.content.imageAlign,
    textAlign: module.content.textAlign,
    content: module.content.body,
    gallery: module.content.gallery,
    sameWidth: true,
    ...(module.content.button && {
      button: module.content.button,
    }),
    ...(module.content.title && {
      title: module.content.title,
    }),
  };

  return (
    <>
      {module.moduleType[0] === "Content" &&
        <div className="moduleRepeaterContent">
          <Content content={content} />
        </div>}
      {module.moduleType[0] === "Gallery" && (
        <div className="moduleRepeaterGallery">
          <Gallery gallery={module.slider.slider} />
        </div>
      )}
    </>
  );
}
